import { render, staticRenderFns } from "./UserProject.vue?vue&type=template&id=bb9c7004&scoped=true&"
import script from "./UserProject.vue?vue&type=script&lang=js&"
export * from "./UserProject.vue?vue&type=script&lang=js&"
import style0 from "./UserProject.vue?vue&type=style&index=0&id=bb9c7004&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb9c7004",
  null
  
)

export default component.exports